const WrapListener = (...listeners) => (event) => listeners.map((listener) => typeof listener === "function" && listener(event));
var WrapListener_default = WrapListener;
export {
  WrapListener_default as default
};
